import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Stack,
  TextField
} from '@mui/material';
import { useEffect } from 'react';
import { Controller, FormProvider, useForm, useWatch } from 'react-hook-form';

import {
  type RecommendationTemplateDTO,
  type TemplateDialogPropsType,
  useAdministrationTemplates
} from '@/pages/Administration/AdministrationTemplates';

const RecommendationTemplateDialog = (props: TemplateDialogPropsType) => {
  const { open, setOpen, templateType, selectedTemplate } = props;
  const { updateTemplate, createTemplate } = useAdministrationTemplates();

  const form = useForm({
    defaultValues: { template: '' }
  });

  const { control, setValue, getValues, handleSubmit } = form;

  const template = useWatch({ control, name: 'template' });

  useEffect(() => {
    setValue('template', selectedTemplate?.template as string);
  }, [selectedTemplate, open]);

  const handleSave = (actionId?: string) => {
    const newTemplateInfo: {
      [key: string]: string | number | RecommendationTemplateDTO;
    } = {};
    const templateData = {
      template: getValues('template')
    };
    newTemplateInfo.templateType = 'recommendation';
    newTemplateInfo.data = templateData;

    if (actionId === 'save') {
      newTemplateInfo.id = selectedTemplate.id as number;
      updateTemplate(
        newTemplateInfo as {
          templateType: string;
          id: number;
          data: RecommendationTemplateDTO;
        }
      );
    } else {
      createTemplate(
        newTemplateInfo as {
          templateType: string;
          data: RecommendationTemplateDTO;
        }
      );
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      fullWidth
      maxWidth="md"
      scroll="paper"
    >
      <DialogTitle>{`${templateType} Template`}</DialogTitle>
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(handleSave as () => void)} noValidate>
          <DialogContent>
            <Stack spacing={2}>
              <div style={{ paddingTop: 10 }}>
                <InputLabel htmlFor="template">Template *</InputLabel>
                <Controller
                  control={control}
                  name="template"
                  rules={{
                    required: true
                  }}
                  render={({ field, formState }) => (
                    <FormControl fullWidth>
                      <TextField
                        id="template"
                        multiline
                        minRows={6}
                        error={!!formState.errors.template}
                        {...field}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => setValue('template', event.target.value)}
                      />
                    </FormControl>
                  )}
                />
              </div>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" sx={{ justifyContent: 'flex-end' }}>
              <Button onClick={() => setOpen(false)}>Cancel</Button>
              {templateType.includes('New') && (
                <Button
                  disabled={(template?.length ?? 0) < 5}
                  type="submit"
                  variant="contained"
                >
                  Create Template
                </Button>
              )}
              {templateType.includes('Edit') && (
                <Button
                  disabled={(template?.length ?? 0) < 5}
                  onClick={() => handleSave('save')}
                  variant="contained"
                >
                  Save Changes
                </Button>
              )}
            </Stack>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default RecommendationTemplateDialog;
